import Registry from './Registry';
/**
 * Synchronous registry
 */

export default class SyncRegistry extends Registry {}